import React from 'react';
import './LogoLoader.css';

/**
 * LogoLoader Component
 * Animated Fokus logo loading spinner with mask reveal and sweep effects
 * 
 * @param {number} size - Size of the loader in pixels (default: 120)
 * @param {string} className - Additional CSS classes
 */
const LogoLoader = ({ size = 120, className = '' }) => {
  // Calculate dimensions maintaining aspect ratio (382:402)
  const aspectRatio = 402 / 382;
  const height = size * aspectRatio;

  return (
    <div className={`logo-loader ${className}`}>
      <svg 
        width={size} 
        height={height} 
        viewBox="0 0 382 402" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="logo-loader__svg"
      >
        <defs>
          {/* Mask that reveals the main shape along its path */}
          <mask id="revealMask">
            <path 
              className="logo-loader__main-reveal" 
              d="M105.85 336.884 
                L105.85 278.848 
                C78.1961 273.185 57.3941 248.703 57.3941 219.358 
                L57.3941 156.752 
                L263.919 156.752 
                C296.845 156.752 324.606 184.286 324.606 218.417 
                C324.606 248.048 303.682 272.706 276.621 278.693 
                L276.621 336.823"
            />
          </mask>
        </defs>
        
        {/* Dim background shape */}
        <path 
          className="logo-loader__main-bg" 
          d="M264.682 99.3255C329.545 99.7438 382 153.418 382 218.417C382 279.377 335.862 330.375 276.621 336.823V278.693C303.682 272.706 324.606 248.048 324.606 218.417C324.606 184.286 296.845 156.752 263.919 156.752H57.3941V219.358C57.3941 248.703 78.1961 273.185 105.85 278.848V336.884C46.6306 330.785 0.386915 280.898 0.00229709 220.122L0 219.358V99.3232H263.919L264.682 99.3255Z"
        />
        
        {/* Revealed shape */}
        <path 
          mask="url(#revealMask)" 
          fill="white" 
          d="M264.682 99.3255C329.545 99.7438 382 153.418 382 218.417C382 279.377 335.862 330.375 276.621 336.823V278.693C303.682 272.706 324.606 248.048 324.606 218.417C324.606 184.286 296.845 156.752 263.919 156.752H57.3941V219.358C57.3941 248.703 78.1961 273.185 105.85 278.848V336.884C46.6306 330.785 0.386915 280.898 0.00229709 220.122L0 219.358V99.3232H263.919L264.682 99.3255Z"
        />
        
        {/* Vertical bar */}
        <path 
          className="logo-loader__vertical-bar" 
          d="M219.697 402H162.773V199.117H219.697V402Z"
        />
        
        {/* Top dot */}
        <path 
          className="logo-loader__top-dot" 
          d="M219.697 56.9578H162.773V0H219.697V56.9578Z"
        />
      </svg>
    </div>
  );
};

export default LogoLoader;
